import { render, staticRenderFns } from "./StationPlatformService.vue?vue&type=template&id=ab7fa24e&scoped=true"
import script from "./StationPlatformService.vue?vue&type=script&lang=ts"
export * from "./StationPlatformService.vue?vue&type=script&lang=ts"
import style0 from "./StationPlatformService.vue?vue&type=style&index=0&id=ab7fa24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7fa24e",
  null
  
)

export default component.exports